const MinimiseIcon = ({}) => {
    return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.40002 15.4558H6.26652C7.44468 15.4558 8.39976 16.3727 8.39976 17.5038V21.5999M8.40002 2.3999V6.49598C8.40002 7.62708 7.44494 8.54402 6.26678 8.54402H2.40029M21.6 15.4558H17.7335C16.5554 15.4558 15.6003 16.3727 15.6003 17.5038V21.5999M15.6 2.3999V6.49598C15.6 7.62708 16.5551 8.54402 17.7333 8.54402H21.5998" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>
}

export default MinimiseIcon;